export const RIGHT_BUTTON = 2;
